<template>
  <div class="main">
    <Header :show="show" @listenEvent="fn" @listenHeight="getHeight" />
    <div
      class="imgshowbox"
      @click="changeShow"
      :style="'margin-top:' + msgboxTop + 'px'"
    >
      <div class="container">
        <img class="titleimg" src="../assets/images/topImg/8.jpg" alt="" />
        <div class="title-box">
          <div class="title-box-bottom">
            <h3 class="big-title">蜂云-云监控平台</h3>
            <p class="title-details">
              蜂云是我司基于全球部署的云服务倾力打造的轻量化公有云监控平台，无需部署本地（内部）服务器
              ，无需专业运维人员，无需复杂的网络设置，设备一键扫码接入，云端统
              一管理，只需要一个平台账号就可以快速建立各类行业项目解决方案，拥有专业的
              视频监控平台。
            </p>
            <!-- <van-button
              v-show="showVideo"
              round
              class="title-box-bottom-video"
              @click="
                () => {
                  this.$router.push({
                    name: 'video',
                    query: {
                      src: 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'
                    }
                  });
                }
              "
            >
              <van-icon :name="require('../assets/images/play.png')" />
              <span>圆形按钮</span>
            </van-button> -->
          </div>
        </div>
      </div>
      <div>
        <van-tabs v-model="active" swipeable animated>
          <van-tab
            v-for="item in messageList"
            :key="item.id"
            :title="item.title"
          >
            <div class="product-box">
              <div class="product-box-top">
                <p class="product-title">
                  {{ item.details }}
                </p>

                <div class="product-button">
                  <span v-for="list in item.buttonList" :key="list.id">
                    <router-link
                      :to="{ path: list.url, query: { src: list.src } }"
                    >
                      <van-button
                        class="title-box-bottom-video change-color"
                        round
                        ><van-icon :name="list.icon"></van-icon>
                        <span class="button-in-box">{{ list.text }}</span>
                      </van-button>
                    </router-link>
                  </span>
                </div>
              </div>

              <div
                class="product-box-middle"
                v-for="article in item.articleList"
                :key="article.id"
              >
                <div class="img-box">
                  <van-image width="100%" fit="contain" :src="article.src" />

                  <div>
                    <h4>{{ article.articletitle }}</h4>
                    <span class="product-details"
                      >{{ article.articledetails }}
                    </span>
                    <div v-for="list in article.traitList" :key="list.id">
                      <h5>{{ list.lightTitle }}</h5>
                      <p v-for="(light, index) in list.lightList" :key="index">
                        {{ light.light }}
                      </p>
                    </div>
                  </div>
                  <p class="linkmore" v-show="article.have">
                    <a :href="article.href">了解更多>>></a>
                  </p>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
export default {
  components: { Header },
  data() {
    return {
      src: "/video",
      show: false,
      active: 0,
      showVideo: true,
      msgboxTop: 0,

      messageList: [
        {
          id: 1,
          title: "智慧学校解决方案",
          details:
            "实现学校智能监控，使被动式监控防御升级为主动式监控防御，帮助学校建立安全、稳定、智能的数字化校园",
          buttonList: [
            // {
            //   id: 1 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 1 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 1 - 1 - 1,
              src: require("../assets/images/product/P499205801.jpg"),
              articletitle: "特殊区域管控",
              articledetails:
                "智能语音播报提醒摄像机自动识别人和机动车目标，自动播报语音提醒，如垃圾分类提醒、危险区域提醒、机动车违停提醒，可自定义智能语音。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            },
            {
              id: 1 - 1 - 2,
              src: require("../assets/images/product/P509205802.jpg"),
              articletitle: "消防通道管控",
              articledetails:
                "消防通道物品滞留检测AI智能精准识别消防通道是否被占用、乱堆物品，物品滞留信息告警推送通知",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            },
            {
              id: 1 - 1 - 3,
              src: require("../assets/images/product/P519205803.jpg"),
              articletitle: "出入人员管控",
              articledetails:
                "人脸抓拍 分析轨迹 定位查询人员黑白名单，对陌生人员进行标注，及时预警。在非正常出园时间，对在校门口徘徊的学生进行预警，通知对应的老师与保安，防止学生自行离校。根据抓拍人脸图片，分析行为轨迹，快速定位人员位置。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            },
            {
              id: 1 - 1 - 4,
              src: require("../assets/images/product/P529205804.jpg"),
              articletitle: "校内学生安全管控",
              articledetails:
                "聚众、打架等智能检测人员聚众聚集检测AI算法，检测和定位区域内人群密度超出指定阔值，自动发送报警提醒。打架检测AI算法，检测校内人员并进行行为分析，发现打架行为自动发送报警提醒。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            },
            {
              id: 1 - 1 - 5,
              src: require("../assets/images/product/P539205805.jpg"),
              articletitle: "数据管控",
              articledetails:
                "精细化权限管理 多用户访问细分了设备管理、报警设置、录像设置、视频预览、录像回放等各类功能的多种权限，支持建立不同权限角色以及建立用户后快速归属角色，方便用户权限的管理；支持无限制数量用户访问。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            }
          ]
        },
        {
          id: 2,
          title: "智慧门店解决方案",
          details:
            "以数据化运营方式，实现店铺数字化精细管理，全面提高店铺管理效能，增强门店引流，为每一个进店客户提供更专业、更优质的消费体验。",
          buttonList: [
            // {
            //   id: 2 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 2 - 2,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 2 - 1 - 1,
              src: require("../assets/images/product/P549205801.jpg"),
              articletitle: "远程智能巡店",
              articledetails:
                "对店面布置、员工状态、商品陈列客户接待、门店卫生等细节进行全方位远程实时管控，发现问题及时抓拍标注，一键下发责任人整改。大幅降低巡店成本，全面提升管理效能。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-433-435.html"
            },

            {
              id: 2 - 1 - 3,
              src: require("../assets/images/product/P559205802.jpg"),
              articletitle: "客流分析",
              articledetails:
                "基于人脸的新一代客流统计分析技术，实现深度流量统计，统计不同人员类型、性别、年龄段的情况、到店时间、新老顾客识别、转化率等进行多维度、深层次的交叉分析。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-433-435.html"
            },
            {
              id: 2 - 1 - 4,
              src: require("../assets/images/product/P569205803.jpg"),
              articletitle: "客流热点轨迹分析",
              articledetails:
                "跟踪店内客流轨迹及空间分布，通过热力图，掌握门店动线及商品热度，优化商品布局，科学调整库存及营销推广规划。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-433-435.html"
            },
            {
              id: 2 - 1 - 5,
              src: require("../assets/images/product/P579205804.jpg"),
              articletitle: "智能语音导购",
              articledetails:
                "AI智能算法技术，摄像机检测到顾客，自动语音播报商品介绍信息，商品促销等信息，可自定义语音导航。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-433-435.html"
            },
            {
              id: 2 - 1 - 6,
              src: require("../assets/images/product/P589205805.jpg"),
              articletitle: "店员人脸识别考勤",
              articledetails:
                "店员人脸快速抓拍识别，快速对比已录入人脸图库，输出考勤信息，提高考勤效率。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-433-435.html"
            }
          ]
        },
        {
          id: 3,
          title: "智慧社区解决方案",
          details:
            "以社区为中心，打造智慧社区生态圈，以智能化监控技术，提高社区档次，增加品牌溢价能力，为社区管理技术换人，提效降本，提升社区业主体验，提高生活质量便利化服务。",
          buttonList: [
            // {
            //   id: 3 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 3 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 3 - 1 - 1,
              src: require("../assets/images/product/P599205801.jpg"),
              articletitle: "高空抛物管控",
              articledetails:
                "视频监控 事件回溯采用枪式摄像机从下往上仰拍，保证社区居民隐私。取证便捷，给予相关人员警告，避免高空抛物现象再发生。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            },
            {
              id: 3 - 1 - 2,
              src: require("../assets/images/product/P609205802.jpg"),
              articletitle: "特殊区域管控",
              articledetails:
                "智能语音播报提醒摄像机自动识别人和机动车目标，自动播报语音提醒，如垃圾分类提醒，危险区域提醒，机动车违停提醒，可自定义智能语音。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            },
            {
              id: 3 - 1 - 3,
              src: require("../assets/images/product/P619205803.jpg"),
              articletitle: "电梯管控",
              articledetails:
                "电瓶车进电梯自动检测AI智能算法，自动识别电瓶车，并联动播报语音提醒，监控中心视频画面弹窗提醒，安保人员远程语音提醒。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            },
            {
              id: 3 - 1 - 4,
              src: require("../assets/images/product/P629205804.jpg"),
              articletitle: "安保人员管控",
              articledetails:
                "离岗自动检测AI智能精准识别安保人员离岗、在岗情况，异常离岗，信息推送通知，异常离岗平台记录统计、查阅调取。",
              have: false,
              href: "https://www.yuncooltech.com/product.html"
            },
            {
              id: 3 - 1 - 5,
              src: require("../assets/images/product/P639205805.jpg"),
              articletitle: "消防通道管控",
              articledetails:
                "消防通道物品滞留检测AI智能精准识别消防通道是否被占用、乱堆物品，物品滞留信息告警推送通知。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            },
            {
              id: 3 - 1 - 6,
              src: require("../assets/images/product/P649205806.jpg"),
              articletitle: "出入人员管控",
              articledetails:
                "人脸抓拍 分析轨迹 定位查询出入口布控人脸抓拍摄像机，人脸实时抓拍更新，实时分析运动轨迹，事后根据人脸快速查找录像，定位可疑人员位置。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            },
            {
              id: 3 - 1 - 7,
              src: require("../assets/images/product/P659205807.jpg"),
              articletitle: "视频数据管控",
              articledetails:
                "大屏显示 数据分析数据中心大屏实时显示所有区域的监控画面，报警视频弹屏提示。分析统计园区进入人数、车辆，进入园区人员画像，识别性别、年龄、进入社区次数等",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            }
          ]
        },
        {
          id: 4,
          title: "明厨亮灶解决方案",
          details:
            "实现厨房智能监控，食品加工过程可视、可感、可知，提高厨房管理效率，提升用餐体验，切实保障用餐安全。",
          buttonList: [
            // {
            //   id: 4 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 4 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 4 - 1 - 1,
              src: require("../assets/images/product/P669205801.jpg"),
              articletitle: "后厨动态可视化",
              articledetails:
                "餐厅大屏幕实时显示厨房内动态活动画面，包括：配菜区、洗菜区、洗碗区、炒菜区等区域，重点区域、重要环节，实现阳光操作。让顾客看得明白，吃得放心。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            },
            {
              id: 4 - 1 - 2,
              src: require("../assets/images/product/P679205802.jpg"),
              articletitle: "后厨违规行为智能化",
              articledetails:
                "集成AI智能算法分析技术，智能识别未穿工作服、未戴厨师帽、未戴口罩、抽烟、玩手机等违规行为，第一时间推送告警信息至管理人员。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            },
            {
              id: 4 - 1 - 3,
              src: require("../assets/images/product/P689205803.jpg"),
              articletitle: "精细化权限管理，多用户访问",
              articledetails:
                "给每个监管人员建立专用账号，分配自己的权限，方便相关人员远程可视化管理以及智能报警提醒。将后厨通过手机客户端展示给用户，允许成百上千的用户接入“阳关厨房”，进行在线监督。如：校园厨房，允许成千上百家长同时观看厨房内所有监控画面，实现在线监督。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            },
            {
              id: 4 - 1 - 4,
              src: require("../assets/images/product/P699205804.jpg"),
              articletitle: "数据统计输出",
              articledetails:
                "每月进行数据统计，输出结果报告&数据，指导改进方向，提高厨房人员管理，改善厨房卫生环境。",
              have: false,
              href: "http://www.jufenginfo.com/product-list-432-312.html"
            }
          ]
        }
      ]
    };
  },
  methods: {
    changeShow() {
      this.show = false;
    },
    fn(val) {
      this.show = val;
    },
    getHeight(val) {
      this.msgboxTop = val;
    }
  },
  watch: {
    msgboxTop(val) {
      this.msgboxTop = val;
    }
  }
};
</script>

<style></style>
